/**
 * @typedef {import('@goodt-wcore/elem').StoreOperationType} StoreOperationType
 */
import { differenceWith, isEqual } from 'lodash';
import { PropChangeContext, PropChangeContextType } from '@goodt-wcore/panel';

export default {
    methods: {
        /**
         * @param newDatasetRequests
         * @param oldDatasetRequests
         */
        onDatasetRequestsChanged(newDatasetRequests, oldDatasetRequests) {
            if (isEqual(newDatasetRequests, oldDatasetRequests)) {
                return;
            }
            const added = differenceWith(newDatasetRequests, oldDatasetRequests, (a, b) => {
                const indexA = newDatasetRequests.indexOf(a);
                const indexB = oldDatasetRequests.indexOf(b);
                return isEqual(a, b) && indexA === indexB;
            });
            const deleted = differenceWith(oldDatasetRequests, newDatasetRequests, (a, b) => {
                const indexA = oldDatasetRequests.indexOf(a);
                const indexB = newDatasetRequests.indexOf(b);
                return isEqual(a, b) && indexA === indexB;
            });

            return this.$createDatasetsChangedContext(added, deleted);
        },
        /**
         * @param {string[]} addedDatasetRequests
         * @param {string[]} deletedDatasetRequests
         * @return {PropChangeContext}
         */
        $createDatasetsChangedContext(addedDatasetRequests, deletedDatasetRequests) {
            const { id: widgetId } = this.elementInstance;
            let added = [];
            let deleted = [];

            if (addedDatasetRequests.length > 0) {
                added = addedDatasetRequests.map(({ query: { $from: datasetCode }, dataProviderId }) => ({
                    widgetId,
                    datasetCode,
                    dataProviderId
                }));
            }
            if (deletedDatasetRequests.length > 0) {
                deleted = deletedDatasetRequests.map(({ query: { $from: datasetCode }, dataProviderId }) => ({
                    widgetId,
                    datasetCode,
                    dataProviderId
                }));
            }
            return new PropChangeContext({
                prop: this.DATASET_PROP,
                type: PropChangeContextType.DATASET,
                details: {
                    added,
                    deleted
                }
            });
        }
    }
};
